import { signal } from "@preact/signals-core";
export const app = signal("qrit");